/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDiag } from '../../factoriesAny.js';
export var diagDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  SparseMatrixDependencies: SparseMatrixDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createDiag: createDiag
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDiag.generated.js
// module id = 1390
// module chunks = 0